import cx from "classnames";
import { Button } from "common/Button";
import { GlobalFooter } from "common/GlobalFooter";
import { TwoTierNav } from "common/TwoTierNav";
import _ from "lodash";
import React from "react";
import Helmet from "react-helmet";
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import appStyles from "../App/appStyles.scss";
import { rrSubnav } from "../IndexPage";
import commonStyles from "./common.scss";
import { RolloutConfirmedPage } from "./RolloutConfirmedPage";
import styles from "./RolloutLandingPage.scss";

const imagePath = "/images/ride_reports_rollout/";

class RolloutLandingPage extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = { videoPaused: true, attemptedEnterContest: false };
    this._throttledOnScroll = _.throttle(this.onScroll, 100); // throttle scroll position check to 10Hz
  }

  componentDidMount = () => {
    window.addEventListener("scroll", this._throttledOnScroll);
    this.onScroll();
  };

  onScroll = (e) => {
    if (!this._videoRef) {
      return;
    }
    const rect = this._videoRef.getBoundingClientRect();

    if (rect.top < -30 || rect.bottom > window.innerHeight + 30) {
      !this._videoPaused && this.pauseVideo();
    } else {
      this._videoPaused && this.playVideo();
    }
  };

  pauseVideo() {
    this._videoRef.pause();
    this._videoPaused = true;
  }

  playVideo() {
    this._videoRef.play();
    this._videoPaused = false;
  }

  setVideoRef = (video) => {
    this._videoRef = video;
  };

  render() {
    let body;
    switch (this.props.location.pathname) {
      case "/ride_reports/rollout/rules":
        body = (
          <div className={styles.Rules}>
            <h3>NO PURCHASE IS NECESSARY TO ENTER OR WIN. A PURCHASE DOES NOT INCREASE THE CHANCES OF WINNING.</h3>
            <ol>
              <li>
                Eligibility: This Campaign is open only to those who sign up at
                https://ridewithgps.com/ride_reports/rollout and who are 18 years of age as of the date of entry. This
                campaign excludes residents of Cuba, Iran, Syria, North Korea, Sudan, Myanmar (Burma), or to other
                individuals restricted by U.S. export controls and sanctions, and is void in any other nation, state, or
                province where prohibited or restricted by U.S. or local law. Employees of Ride with GPS, LLC, its
                affiliates, subsidiaries, advertising and promotion agencies, sponsors, promotion partners, and
                suppliers, (collectively the “Employees”), and immediate family members and/or those living in the same
                household of Employees are not eligible to participate in the Campaign. The Campaign is subject to all
                applicable federal, state, and local laws and regulations. Void where prohibited.
              </li>
              <li>
                Agreement to Rules: By participating, the Contestant (“You”) agree to be fully unconditionally bound by
                these Rules, and You represent and warrant that You meet the eligibility requirements. In addition, You
                agree to accept the decisions of Ride with GPS, LLC as final and binding as it relates to the content of
                this Campaign.
              </li>
              <li>
                Campaign Period: Entries will be accepted online starting on March 1 2017 12:00am Pacific Time and
                ending May 1 2017 11:59pm Pacific Time. All online entries must be received by May 1 2017 11:59pm
                Pacific Time.
              </li>
              <li>
                How to Enter: The Campaign must be entered by clicking signup buttons available at
                https://ridewithgps.com/ride_reports/rollout. Signing up for the Campaign requires creating an account
                on https://ridewithgps.com, and the Entrant agrees to be bound by the terms of service outlined at
                https://ridewithgps.com/terms and the privacy policy outlined at https://ridewithgps.com/privacy. Once
                an Entrant has signed up for the Campaign, they must then create and publish a qualifying Ride Report
                (“Entry”) during the Campaign Period. The entry must fulfill all Campaign requirements, as specified, to
                be eligible to win a prize. Entries that are incomplete or do not adhere to the rules or specifications
                may be disqualified at the sole discretion of Ride with GPS, LLC. You must provide the information
                requested. You may not enter more times than indicated by using multiple email addresses, identities, or
                devices in an attempt to circumvent the rules. If You use fraudulent methods or otherwise attempt to
                circumvent the rules, your submission may be removed from eligibility at the sole discretion of Ride
                with GPS, LLC.
                <ol type="a">
                  <li>Entries must contain one or more photos</li>
                  <li>
                    Entries must contain a valid GPS recording of an activity, not limited to biking, that was performed
                    by the author in question during the Campaign Period
                  </li>
                  <li>Entries must contain more than 200 words of written text</li>
                  <li>
                    Entries must not contain material that violates or infringes another’s rights, including, but not
                    limited to, material that violates privacy, publicity, or intellectual property rights, or that
                    constitutes copyright or trademark infringement
                  </li>
                  <li>
                    Entries must not include third parties, including but not limited to minors and friends who have not
                    expressly authorized Entrant to display their image or likeness in any submitted photo or otherwise
                    use such image or likeness in accordance with these Official Rules.
                  </li>
                </ol>
              </li>
              <li>
                Prizes: The Winner(s) of the Campaign (the “Winner”) will receive one of the following prizes:
                Breadwinner B-Road Bike ARV $6500, Hand Built Wheels from Sugar Wheels ARV $1000, Weekly Prize Package
                with $120 PDW Gift card, Bicycle tires, and Ride with GPS Merchandise for total ARV of $350.
                Actual/appraised value may differ at time of prize award. The specifics of the prize shall be solely
                determined by Ride with GPS, LLC. No cash or other prize substitution shall be permitted except at Ride
                with GPS, LLC discretion. The prize is nontransferable. Any and all prize-related expenses, including
                without limitation any and all federal, state, and/or local taxes, shall be the sole responsibility of
                Winner. No substitution of prize or transfer/assignment of prize to others or request for the cash
                equivalent by Winner is permitted. Acceptance of prize constitutes permission for Ride with GPS, LLC to
                use Winner’s name, likeness, and entry for purposes of advertising and trade without further
                compensation, unless prohibited by law.
              </li>
              <li>Odds: The odds of winning one of the prizes depend on the number of eligible entries received.</li>
              <li>
                Winner Selection and Notification: Weekly and bi-weekly Winner (Prize Package and Custom Wheels) will be
                selected by a random drawing of all submitted Ride Reports during the drawing period, under the
                supervision of Ride with GPS, LLC. Grand Prize Winner will be selected by community voting on the top 10
                submitted Ride Reports meeting selection criteria. The top 10 Ride Reports will be selected by an expert
                panel of 10 cyclists on the following criteria: (a) quality and composition of photos, (b) the quality
                of writing and how it ties together all components of the Ride Report, and how it celebrates the spirit
                of riding, and (c) how the Ride Report author acts as an ambassador to the sport. The decisions of the
                panel are final and binding. The Winner will be notified by email within five (5) days following
                selection of Winner. Ride with GPS, LLC shall have no liability for Winner’s failure to receive notices
                due to spam, junk e-mail or other security settings or for Winner’s provision of incorrect or otherwise
                non-functioning contact information. If Winner cannot be contacted, is ineligible, fails to claim the
                prize within 15 days from the time award notification was sent, or fails to timely return a completed
                and executed declaration and release as required, the prize may be forfeited and an alternate Winner
                selected. Receipt by Winner of the prize offered in this Campaign is conditioned upon compliance with
                any and all federal, state, and local laws and regulations. ANY VIOLATION OF THESE OFFICIAL RULES BY
                WINNER (AT Ride with GPS, LLC‘S SOLE DISCRETION) WILL RESULT IN WINNER’S DISQUALIFICATION AS WINNER OF
                THE CAMPAIGN, AND ALL PRIVILEGES AS WINNER WILL BE IMMEDIATELY TERMINATED.
              </li>
              <li>
                Rights Granted by You: By entering this content (e.g., photo, video, text, etc.), You understand and
                agree that Ride with GPS, LLC, anyone acting on behalf of Ride with GPS, LLC, and Ride with GPS, LLC’s
                licensees, successors, and assigns, shall have the right, where permitted by law, to print, publish,
                broadcast, distribute, and use in any media now known or hereafter developed, in perpetuity and
                throughout the World, without limitation, your entry, name, portrait, picture, voice, likeness, image,
                statements about the Campaign, and biographical information for news, publicity, information, trade,
                advertising, public relations, and promotional purposes, without any further compensation, notice,
                review, or consent. By entering this content, You represent and warrant that your entry is an original
                work of authorship, and does not violate any third party’s proprietary or intellectual property rights.
                If your entry infringes upon the intellectual property right of another, You will be disqualified at the
                sole discretion of Ride with GPS, LLC. If the content of your entry is claimed to constitute
                infringement of any proprietary or intellectual proprietary rights of any third party, You shall, at
                your sole expense, defend or settle against such claims. You shall indemnify, defend, and hold harmless
                Ride WIth GPS, LLC from and against any suit, proceeding, claims, liability, loss, damage, costs or
                expense, which Ride with GPS, LLC may incur, suffer, or be required to pay arising out of such
                infringement or suspected infringement of any third party’s right.
              </li>
              <li>
                Terms & Conditions: Ride with GPS, LLC reserves the right, in its sole discretion, to cancel, terminate,
                modify or suspend the Campaign should virus, bug, non-authorized human intervention, fraud, or other
                cause beyond Ride with GPS, LLC’s control corrupt or affect the administration, security, fairness, or
                proper conduct of the Campaign. In such case, Ride with GPS, LLC may select the Winner from all eligible
                entries received prior to and/or after (if appropriate) the action taken by Ride with GPS, LLC. Ride
                with GPS, LLC reserves the right, in its sole discretion, to disqualify any individual who tampers or
                attempts to tamper with the entry process or the operation of the Campaign or website or violates these
                Terms & Conditions. Ride with GPS, LLC has the right, in its sole discretion, to maintain the integrity
                of the Campaign, to void votes for any reason, including, but not limited to: multiple entries from the
                same user in excess of that allowed by Campaign rules; or the use of bots, macros, scripts, or other
                technical means for entering. Any attempt by an entrant to deliberately damage any website or undermine
                the legitimate operation of the Campaign may be a violation of criminal and civil laws. Should such
                attempt be made, Ride with GPS, LLC reserves the right to seek damages to the fullest extent permitted
                by law.
              </li>
              <li>
                Limitation of Liability: By entering, You agree to release and hold harmless Ride with GPS, LLC and its
                subsidiaries, affiliates, advertising and promotion agencies, partners, representatives, agents,
                successors, assigns, employees, officers, and directors from any liability, illness, injury, death,
                loss, litigation, claim, or damage that may occur, directly or indirectly, whether caused by negligence
                or not, from: (i) such entrant’s participation in the Campaign and/or his/her acceptance, possession,
                use, or misuse of any prize or any portion thereof; (ii) technical failures of any kind, including but
                not limited to the malfunction of any computer, cable, network, hardware, or software, or other
                mechanical equipment; (iii) the unavailability or inaccessibility of any transmissions, telephone, or
                Internet service; (iv) unauthorized human intervention in any part of the entry process or the
                Promotion; (v) electronic or human error in the administration of the Promotion or the processing of
                entries.
              </li>
              <li>
                Disputes: THIS Campaign IS GOVERNED BY THE LAWS OF THE UNITED STATES AND Oregon, WITHOUT RESPECT TO
                CONFLICT OF LAW DOCTRINES. As a condition of participating in this Campaign, participant agrees that any
                and all disputes that cannot be resolved between the parties, and causes of action arising out of or
                connected with this Campaign, shall be resolved individually, without resort to any form of class
                action, exclusively before a court located in Oregon having jurisdiction. Further, in any such dispute,
                under no circumstances shall participant be permitted to obtain awards for, and hereby waives all rights
                to, punitive, incidental, or consequential damages, including reasonable attorney’s fees, other than
                participant’s actual out-of-pocket expenses (i.e. costs associated with entering this Campaign).
                Participant further waives all rights to have damages multiplied or increased.
              </li>
              <li>
                Privacy Policy: Information submitted with an entry is subject to the Privacy Policy stated on
                https://ridewithgps.com/privacy.
              </li>
              <li>
                Winners List: To obtain a copy of the Winner’s name or a copy of these Official Rules, mail your request
                along with a stamped, self-addressed envelope to: Ride with GPS, 2222 NE Oregon St. STE 210, Portland,
                OR 97232, United States of America. Requests must be received no later than May 31st, 2017.
              </li>
              <li>
                Sponsors: The Sponsor of the Campaign is Ride with GPS, 2222 NE Oregon St STE 210, Portland, OR 97232.
              </li>
              <li>
                Miscellaneous: Each winner must sign Ride with GPS, LLC’s release form and affidavit of eligibility to
                claim the prize. Ride with GPS, LLC’s may substitute prizes, amend the rules or discontinue the Campaign
                at any time. Ride with GPS, LLC’s disclaims any responsibility to notify participants of any aspect
                related to the conduct of the Campaign.
              </li>
              <li>
                Social Media: The Campaign hosted by Ride with GPS, LLC is in no way sponsored, endorsed, administered
                by, or associated with Facebook, Instagram, or Twitter.
              </li>
            </ol>
          </div>
        );
        break;
      default:
        body = (
          <div>
            <header className={styles.header}>
              <div className={styles.headerInner}>
                <img className={styles.headerLogo} src={`${imagePath}logo.png`} />
                <div className={styles.headerDetails}>
                  <h1>Ride Report Contest</h1>
                  <p>
                    For the launch of our Ride Reports feature in the spring of 2017, we challenged our users to go on
                    rides that challenged and inspired them, then share those rides with the community in the form of a
                    Ride Report. Prizes up for grabs included tons of great PDW swag, two sets of handbuilt Sugar
                    wheels, and a fully-custom Breadwinner B-Road adventure bike!
                  </p>
                  <Link to="/ride_reports/rollout2017">
                    <Button className={commonStyles.primaryButton}>View Winners</Button>
                  </Link>
                </div>
                <div className={styles.headerDates}>March 01 - May 01, 2017</div>
              </div>
            </header>
            <main>
              <section className={styles.section}>
                <div className={styles.sectionDescription}>
                  <h2>Wait, What is a Ride Report?</h2>
                  <p>
                    Great question! Ride Reports make it easy to create beautiful, rich stories of your rides that are
                    easily enjoyed by friends and family. Think the Medium of bike riding, complete with interactive
                    maps, photo collages, and other story telling aides. Join the contest, browse existing Reports for
                    inspiration, ride between March 1st and May 1st, then create your own!
                  </p>
                  <Link to="/ride_reports/rollout2017">
                    <Button className={commonStyles.primaryButton}>View Winners</Button>
                  </Link>
                </div>
              </section>
              <section className={styles.section}>
                <div className={styles.sectionDescription}>
                  <h2>Record Your Ride</h2>
                  <p>
                    First, go out on a great ride, and record it using our mobile app or your favorite GPS device. Have
                    a blast, and don’t forget to take photos! If you are using our app, any pictures you take will
                    automatically be associated with your ride. Need some inspiration? Checkout our{" "}
                    <a href="/ambassadors">Ambassador Directory</a> or <a href="/ride_reports">Featured Ride Reports</a>
                    .
                  </p>
                  <div className={styles.statement}>
                    Using Ride with GPS is <i>free</i>
                  </div>
                </div>
                <div className={styles.sectionImage}>
                  <img src={`${imagePath}record-ride.jpg`} />
                </div>
              </section>
              <section className={styles.section}>
                <div className={styles.sectionDescription}>
                  <h2>Create Your Report</h2>
                  <p>
                    Once you’ve recorded a great ride, the hard part is done. Creating your Ride Report is easy and fun!
                    Share your ride experience using words, photos, maps, and more. Challenge yourself to be creative;
                    with Ride Reports, a commute can be an exciting adventure, a training ride can be a journey of self
                    discovery, and a bikepacking trip can be a tale for the ages.
                  </p>
                  <div className={styles.statement}>Create your report by May 1</div>
                </div>
                <div className={styles.sectionImage}>
                  <video
                    muted
                    ref={this.setVideoRef}
                    preload="auto"
                    className={styles.demoVideo}
                    width="510"
                    height="364"
                  >
                    <source src={`${imagePath}rr-demo-40s-smaller-optimized.mp4`} type="video/mp4" />
                    <source src={`${imagePath}rr-demo-40s-smaller-optimized.webm`} type="video/webm" />
                  </video>
                </div>
              </section>
              <section className={styles.section}>
                <div className={styles.sectionDescription}>
                  <h2>Share &amp; Vote</h2>
                  <p>
                    On May 2, we’ll select the 10 best Ride Reports, and you’ll have the opportunity to vote for your
                    favorite. The author of the report with the most votes on May 10th will win a fully custom
                    Breadwinner B-Road bike! This beauty will be hand built in Portland, OR to your exact dimensions,
                    and you can even customize the paint.
                  </p>
                  <p>
                    As Ride Reports roll in, we’ll select a random participant every two weeks during the contest to
                    receive a set of hand-built wheels. Whether you report on the Tour Divide or your Cat 6 commute, you
                    will have an equal chance to win a custom wheelset from Sugar Wheel Works. We’ll also have a weekly
                    giveaway featuring gift certificates from Portland Design Works, Schwalbe tires, and assorted Ride
                    with GPS schwag.
                  </p>
                  <div className={styles.statement}>
                    Winners announced weekly
                    <br />
                    Grand prize May 10
                  </div>
                </div>
                <div className={styles.sectionImage}>
                  <img src={`${imagePath}share-image.jpg`} />
                </div>
              </section>
              <section className={styles.calloutSection}>
                <div className={styles.calloutInner}>
                  <h3>View featured Ride Reports to get inspired for your next adventure.</h3>
                  <div className={styles.calloutButtons}>
                    <Link to="/ride_reports/">
                      <Button className={commonStyles.whiteButton}>See Featured</Button>
                    </Link>
                    <Link to="/ride_reports/rollout2017">
                      <Button className={commonStyles.whiteButton}>View Contest Winners</Button>
                    </Link>
                  </div>
                </div>
              </section>
              <div className={styles.grandPrize}>
                <div className={styles.fakeCarousel}>
                  <img src={`${imagePath}bike1.jpg`} />
                </div>
                <section className={styles.prizeSection}>
                  <div className={styles.fiveCols}>
                    <div className={styles.statement}>Grand prize</div>
                    <h2>Win a custom Breadwinner B&#8209;Road Gravel Grinder Bike</h2>
                  </div>
                  <div className={styles.fourCols}>
                    <p>
                      We think Ride Reports are such a great feature, we decided they deserved a great bike. We can't
                      imagine a better pairing than a custom B-Road, hand built in Portland, OR by our friends at
                      Breadwinner Cycles. With an MSRP of $6,500, this is no low end build! Equally at home on pavement,
                      gravel, or dirt, the bike is fully equipped with <strong>Shimano Ultegra</strong>,{" "}
                      <strong>Chris King components</strong> and will roll on <strong>HED wheels</strong>, built by
                      Portland's own Sugar Wheel Works.
                    </p>
                    <p>
                      More pictures are available on the{" "}
                      <a href="http://breadwinnercycles.com/product/b-road/" target="_blank">
                        Breadwinner website
                      </a>
                    </p>
                  </div>
                </section>
              </div>
              <section className={styles.prizeSection}>
                <div className={styles.fourCols}>
                  <div className={styles.statement}>Finalist prizes</div>
                  <h2>Custom Sugar Wheel Works Wheels</h2>
                  <p>
                    These wheels are no consolation prize. Three lucky winners will have the opportunity to work with
                    Jude, founder of Sugar Wheel Works, to create the road, adventure, or MTB wheelset of their dreams,
                    built around top-of-the-line <strong>White Industries</strong> hubs. We will be giving away
                    wheelsets every two weeks throughout the contest, so make sure to submit Ride Reports regularly for
                    a chance to win. Can't wait? Check out what Sugar has to offer on their website,{" "}
                    <a href="https://sugarwheelworks.com/" target="_blank">
                      sugarwheelworks.com
                    </a>
                  </p>
                </div>
                <div className={styles.fiveCols}>
                  <img src={`${imagePath}sugar-wheels.jpg`} />
                </div>
              </section>
              <section className={styles.prizeSection}>
                <div className={styles.fourCols}>
                  <div className={styles.statement}>Weekly prizes</div>
                  <h2>Portland Design Works Gift Cards &amp; Prizes</h2>
                  <p>
                    We’ll also be selecting the best report submitted each week to be featured on social media. The
                    authors will each receive a $120 gift card for{" "}
                    <a href="https://ridepdw.com" target="_blank">
                      Portland Design Works
                    </a>
                    , along with a set of Schwalbe tires of their choice courteousy of Sugar Wheel Works, a Ride with
                    GPS Jersey, T-Shirt, and water bottle.
                  </p>
                  <p>
                    You can see our made in USA Castelli jersey{" "}
                    <a href="https://ridewithgps.com/products/Jersey" target="_blank">
                      here
                    </a>
                    .
                  </p>
                </div>
                <div className={styles.fourCols}>
                  <div className={styles.statement}>Sponsors</div>
                  <div className={styles.logos}>
                    <a href="https://breadwinnercycles.com" target="_blank">
                      <img className={styles.breadwinnerLogo} src={`${imagePath}breadwinner-logo.png`} />
                    </a>
                    <a href="https://sugarwheelworks.com" target="_blank">
                      <img className={styles.sugarLogo} src={`${imagePath}sugar-logo.png`} />
                    </a>
                    <a href="https://ridepdw.com" target="_blank">
                      <img className={styles.pdwLogo} src={`${imagePath}pdw-logo-bw.png`} />
                    </a>
                  </div>
                </div>
              </section>
              <section className={styles.closing}>
                <div className={styles.headerInner}>
                  <img className={styles.headerLogo} src={`${imagePath}logo.png`} />
                  <div className={styles.headerDetails}>
                    <div className={styles.headerDates}>March 01 - May 01</div>
                    <h1>Report Your Next Bike Adventure</h1>
                    <Link to="/ride_reports/rollout2017">
                      <Button className={commonStyles.primaryButton}>View Winners</Button>
                    </Link>
                  </div>
                </div>
              </section>
              <section className={styles.finalDetails}>
                <div className={styles.finalDetail}>
                  <div className={styles.statement}>Ride Report Questions</div>
                  <p>
                    Need help? We have the best support in the industry! Take a minute to browse through our Ride Report
                    specific{" "}
                    <a href="https://ridewithgps.com/help/ride-reports" target="_blank">
                      help
                    </a>
                    , or email your question to <a href="mailto:info@ridewithgps.com">info@ridewithgps.com</a>
                  </p>
                  <p>
                    <a href="https://ridewithgps.com/help/ride-reports" target="_blank">
                      View Our Help Center
                    </a>
                  </p>
                </div>
                <div className={styles.finalDetail}>
                  <div className={styles.statement}>Contest Rules</div>
                  <p>
                    By clicking one of the contest entry links, participants agree to be bound by the official contest
                    rules. For detailed rules, visit the link below.
                  </p>
                  <p>
                    <Link to="/ride_reports/rollout/rules">View Official Contest Rules</Link>
                  </p>
                </div>
                <div className={styles.finalDetail}>
                  <div className={styles.statement}>Press & Media</div>
                  <p>
                    Interested in writing about the Ride Report Rollout? Email us for official assets or any premade
                    copy you might need.
                  </p>
                  <p>
                    <a href="mailto:info@ridewithgps.com">info@ridewithgps.com</a>
                  </p>
                </div>
              </section>
            </main>
          </div>
        );
    }
    return (
      <div className={cx(styles.RolloutLandingPage, commonStyles.Page, appStyles.base)}>
        <Helmet title="Ride Reports · Rollout Contest" />
        <TwoTierNav
          secondaryNav={rrSubnav({
            currentUser: this.props.currentUser,
            draftCount: this.props.draftCount,
          })}
        />
        {body}
        <GlobalFooter />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  currentUser: state.currentUser,
  draftCount: state.editPage.draftList.size,
});

const mapDispatchToProps = (dispatch) => ({});

export const RolloutLandingPageContainer = connect(mapStateToProps, mapDispatchToProps)(withRouter(RolloutLandingPage));

export const RolloutConfirmedPageContainer = connect(mapStateToProps, mapDispatchToProps)(RolloutConfirmedPage);
